angular.module('resCenAppModule', ['resCenAppLeftModule', 'resCenterAppRouterModule', 'appQuickPreview'])
    .controller('resCenAppMainCtrl', ['$scope', '$q', '$element', '$interval', '$state', '$location', '$modal', 'resCtrModalService', 'initComDataService', 'resourceCenterService', 'trsspliceString', 'modalDialog', 'dateFilter', 'globleParamsSet', 'trsHttpService', '$timeout', 'trsPrintService', 'storageListenerService', '$stateParams',
        function($scope, $q, $element, $interval, $state, $location, $modal, resCtrModalService, initComDataService, resourceCenterService, trsspliceString, modalDialog, dateFilter, globleParamsSet, trsHttpService, $timeout, trsPrintService, storageListenerService, $stateParams) {
            initStatus();
            initData();

            /**
             * [initStatus description] 状态初始化
             */
            function initStatus() {
                $scope.childStatus = {
                    // 图片数组的string
                    checkString: 'imgurl',
                    // 图片数组中表示url地址的string
                    picString: 'urlS',
                    originPicUrl: 'urlM'
                };
                // 初始化分页参数
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: globleParamsSet.setResourceCenterPageSize,
                };
                // 初始化数据
                $scope.data = {
                    casDataArea: [], // 地区的级联数组
                    themeType: {}, // 主题参数
                    keyType: {}, // 搜索词的类型
                    selectedArray: [], // 当前的选择项
                    currPage: 1, // 当前页数
                    docType: {
                        data: [],
                        curValue: {}
                    }, // 稿件类型
                    timeType: {}, // 时间类型
                    itemCounts: 0 // 显示的稿件数量
                };
                $scope.basicParams = {
                    channelName: 'app',
                    typeName: $stateParams.typename,
                    nodeId: $stateParams.nodeid,
                };
                // 请求列表的参数,有一些写死的参数
                $scope.params = {
                    typeid: 'zyzx',
                    serviceid: 'app',
                    modelId: 'findFromNavigation',
                    pageSize: $scope.page.PAGESIZE,
                    pageNum: $scope.page.CURRPAGE,
                    keyword: '',
                };
                var paramsArray = $stateParams.param_data.split('&');
                for (var i in paramsArray) {
                    var attribute = paramsArray[i].toLowerCase();
                    $scope.params[attribute] = $stateParams[attribute];
                }
                // 检索词参数
                $scope.keyword = {
                    searchType: '', // 查询类型
                    keywords: '', // 关键词
                    time: '', // 时间范围
                    area: '', // 地域
                    zyzxfield: '', // 主题
                    isOriginal: '', // 是否原创
                    isHead: '', // 是否头版
                    isRead: '', // 是否10w+
                    menuscriptType: '', // 稿件类型
                    medianame: $state.params.medianame,
                };
                $scope.status = {
                    channelType: $stateParams.channeltype, // 栏目类型
                    isSzbPage: false, // 是否为数字报版面布局
                    screenWrapSelected: false, // 是否显示更多筛选
                    singleGraph: false, // 是否为单图模式
                    isrepetite: false,
                    displayPreview: false,
                    iwoEdit: {
                        1: 'iwonews',
                        2: 'iwoatlas',
                    },
                    newspaperEdit: {
                        1: 'newspapertext',
                        2: 'newspaperpic',
                    },
                    websiteEdit: {
                        1: 'websitenews',
                        2: 'websiteatlas',
                    },
                    hasphoto: false, // 是否显示图集
                    multiImgsReady: false // 多图加载完成
                };
            }

            /**
             * [initData description] 数据初始化
             */
            function initData() {
                listenStorage();
                // 检索字段
                $scope.data.keyType = {
                    data: initComDataService.searchBigdataType(),
                    curValue: initComDataService.searchBigdataType()[0]
                };
                getDraftType();
                getThemeData().then(function() {
                    if (angular.isDefined($scope.$root.filterDataBack)) { // 判断是否有传递的数据
                        var filterDataBack = angular.copy($scope.$root.filterDataBack);
                        $scope.page = filterDataBack.page;
                        $scope.data.fromdate = filterDataBack.fromdate;
                        $scope.data.untildate = filterDataBack.untildate;
                        $scope.keyword = $scope.params.keyword = filterDataBack.paramsKeyword;
                        $scope.params.pageNum = $scope.page.CURRPAGE;
                        $scope.params.pageSize = $scope.page.PAGESIZE;
                        $scope.data.docType = filterDataBack.docType; // 当前稿件类型
                        $scope.data.themeType = filterDataBack.themeType; // 当前主题
                        $scope.data.keyType = filterDataBack.keyType; // 当前检索信息
                        // 默认展开更多筛选项
                        if ($scope.data.docType.curValue.value != '0' || filterDataBack.area != undefined) {
                            $scope.status.screenWrapSelected = true;
                        }
                        // 默认选中地域
                        if (filterDataBack.area) {
                            $scope.data.casDataArea.push(filterDataBack.area[0]);
                            $scope.data.area = filterDataBack.area;
                        }
                        if (filterDataBack.listData) { // 是否图集稿，是则直接传递图集列表数据
                            $scope.status.hasphoto = true;
                            $scope.data.listData = filterDataBack.listData;
                            $scope.status.singleGraph = filterDataBack.singleGraph; // 是否单图
                            $timeout(function() {
                                $scope.data.items = $scope.data.listData;
                                initOperFlag();
                            }, 100);
                            storageListenerService.previewPageTurningStorage($scope.data.listData, 'ZB_GUID', 'resourceDetail');
                        } else {
                            requestData();
                        }
                        $timeout(function() {
                            $scope.$on('$destroy', function() { // 销毁对象
                                delete $scope.$root.filterDataBack;
                            });
                        });
                    } else {
                        requestData();
                    }
                });
            }

            /**
             * [listenStorage description]监听本地缓存
             * @return {[promise]} [description] promise
             */
            function listenStorage() {
                storageListenerService.listenResource(function() {
                    requestData();
                    storageListenerService.removeListener('resource');
                }, $scope);
            }

            /**
             * [showSelectedArea description：数据地域信息的级联菜单获取数据]
             * @param   {[type]}  node  [node description]选中的节点
             * @return  {[type]}        [return description]
             */
            $scope.showSelectedArea = function(node) {
                var defer = $q.defer();
                resourceCenterService.getArea(node).then(function(data) {
                    defer.resolve(data);
                });
                return defer.promise;
            };

            /**
             * [getThemeData description：获取主题数据]
             */
            function getThemeData() {
                var defer = $q.defer();
                var themeParams = {
                    serviceid: 'navigation',
                    typeid: 'zyzx',
                    modelid: 'base',
                    parentId: '-1',
                    level: '2',
                    excludeId: '-1',
                    containParent: false,
                    channelName: 'app',
                    typeName: 'zyzxfield'
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), themeParams, 'post').then(function(themeData) {
                    $scope.data.themeType = {
                        data: [{
                            dictName: '所有主题',
                            id: ''
                        }].concat(themeData),
                        curValue: {
                            dictName: '所有主题',
                            id: ''
                        }
                    };
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [getSearchParams description：获取搜索词类型]
             */
            function getSearchParams() {

            }

            /**
             * [getDraftType description：获取稿件类型]
             */
            function getDraftType() {
                var defer = $q.defer();
                var params = {
                    typeid: 'zyzx',
                    modelid: 'getSearchMenu',
                    serviceid: 'app',
                    channelName: 'app',
                    typeName: 'zyzxfield',
                    nodeId: 'zyzxfield_001001',
                    menuName: 'menuscriptType',
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                    $scope.data.docType.data = new Array();
                    for (var i = 0; i < data.content[0].length; i++) {
                        $scope.data.docType.data[i] = {
                            name: data.content[0][i].ENNAME,
                            value: data.content[0][i].CNNAME,
                        };
                    }
                    if ($scope.data.docType.data.length >= 1) {
                        $scope.data.docType.curValue = $scope.data.docType.data[0];
                    }
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [filterName description] 处理客户端名字
             * @return {[type]}           [description]
             */
            $scope.filterName = function(title) {
                if (typeof title === 'string' && title.indexOf('客户端') > -1) {
                    return title.replace('客户端', '');
                } else {
                    return title;
                }
            };

            /**
             * [getFilterVal description：获取过滤信息]
             * @param {Object} key 参数类型
             * @param {Object} val 需要的过滤数据
             */
            $scope.getFilterVal = function(key, val, val2) {
                switch (key) {
                    case 'area':
                        // 获取ID
                        $scope.keyword.area = val[0][val[0].length - 1].id;
                        break;
                    case 'time':
                        // 获取开始和结束时间
                        var st = $scope.data.untildate.replace(new RegExp('-', 'gm'), '/');
                        var et = $scope.data.fromdate.replace(new RegExp('-', 'gm'), '/');
                        if (st == '' && et == '') {
                            $scope.keyword.time = '';
                        } else {
                            $scope.keyword.time = st + ',' + et;
                        }
                        if ($scope.status.isrepetite && st == '') {
                            return;
                        }
                        break;
                    case 'zyzxfield':
                        // 获取主题
                        $scope.keyword.zyzxfield = val;
                        break;
                    case 'doctype':
                        // 获取文件类型
                        $scope.keyword.menuscriptType = val;
                        if (val === '2') {
                            $scope.status.hasphoto = true;
                        } else {
                            $scope.status.hasphoto = false;
                        }
                        break;
                    case 'keyword':
                        // 获取文件类型
                        $scope.keyword.keywords = val;
                        $scope.keyword.searchType = $scope.data.keyType.curValue.value;
                        break;
                }
                if ($scope.data.fromdate == '') {
                    $scope.status.isrepetite = true;
                } else {
                    $scope.status.isrepetite = false;
                }
                clearPageData();
                // 刷新列表
                requestData();
            };

            /**
             * [clearPageData 清楚列表数据]
             */
            function clearPageData() {
                $scope.params.pageNum = 1;
                $scope.data.items = [];
                $scope.data.selectedArray = [];
                $scope.status.unloadover = true;
            }

            /**
             * [requestData description：获取列表数据]
             */
            function requestData() {
                $scope.params.keyword = JSON.stringify($scope.keyword);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function(data) {
                    $scope.data.headers = data.summary_info.hybaseField; // 表头信息
                    $scope.page = data.summary_info; // 分页信息
                    $scope.basicParams.indexName = data.summary_info.indexName;
                    $scope.data.selectedArray = []; // 清空之前的选择数据
                    // 循环数组 给数据加上序号
                    for (var i = 0; i < data.content.length; i++) {
                        data.content[i].NUMBER = (($scope.page.CURRPAGE - 1) * $scope.page.PAGESIZE + i + 1).toString();
                    }
                    // 判断是否是图集稿件
                    if ($scope.status.hasphoto) {
                        $scope.data.itemCounts = 0;
                        $scope.status.multiImgsReady = false;
                        $scope.data.items = data.content;
                        // $scope.data.items = $scope.data.items.concat(data.content);
                    } else {
                        $scope.data.items = data.content;
                        findReprintCounts();
                    }

                    /* if ($scope.status.Only) {
                        $scope.status.itemsPaiChong = listPaiChong(data.content, "DOCTITLE", "ZB_SOURCE_SITE"); //经过排重的数据
                        $scope.data.itemstemporary = $scope.status.itemsPaiChong;
                    } else {
                        $scope.data.itemstemporary = data.content;
                        initOperFlag();
                    }*/
                    storageListenerService.previewPageTurningStorage($scope.data.items, 'ZB_GUID', 'resourceDetail');
                    getImgList(data.content);
                });
            }

            /**
             * 请求图片数据
             * @param {Object} list
             */
            function getImgList(list) {
                var docIds = trsspliceString.spliceString(list, 'ZB_GUID', ',');
                if (docIds) {
                    var params = {
                        typeid: 'zyzx',
                        modelid: 'getImgList',
                        serviceid: $scope.basicParams.channelName,
                        channelName: $scope.basicParams.channelName,
                        guids: docIds
                    };
                    trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                        if (data.result == 'success') {
                            var temp = data.content[0];
                            var index = 0; 
                            // var index = $scope.status.hasphoto ? ($scope.params.pageNum - 1) * $scope.params.pageSize : 0;
                            for (var i = index; i < $scope.data.items.length; i++) {
                                var value = $scope.data.items[i];
                                if (!value.imgurl) {
                                    value.width = temp[value.ZB_GUID] && temp[value.ZB_GUID].IMAGEURLS[0].wight;
                                    value.height = temp[value.ZB_GUID] && temp[value.ZB_GUID].IMAGEURLS[0].height;
                                    value.imgurl = temp[value.ZB_GUID] && temp[value.ZB_GUID].IMAGEURLS;
                                }
                            }
                            $scope.status.multiImgsReady = true;
                            for (var j = 0; j < $scope.data.items.length; j++) {
                                if (!$scope.data.items[j].lastLineHide) {
                                    $scope.data.itemCounts++;
                                }
                            }
                            $timeout(function() {
                                initOperFlag();
                            });
                        }
                    });
                }
            }

            /**
             * [findReprintCounts description] 获取转载量
             * @return {[type]} [description]
             */
            function findReprintCounts() {
                var tags = trsspliceString.spliceString($scope.data.items, 'MD5TAG', ',');
                if (!!tags) {
                    var params = {
                        typeid: 'zyzx',
                        serviceid: 'app',
                        modelId: 'findReprintCounts',
                        tags: tags
                    };
                    trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                        $timeout(function() {
                            for (var i = 0; i < $scope.data.items.length; i++) {
                                $scope.data.items[i].REPRINTS_COUNT = data.content[0][$scope.data.items[i].MD5TAG];
                            }
                        });
                    });
                }
            }

            /**
             * [determineSelected description] 判断是否有选中稿件
             */
            function determineSelected() {
                if (!$scope.data.selectedArray.length) {
                    modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                    return false;

                } else {
                    return true;
                }
            }

            /**
             * [openTakeDraftModal description]取稿
             */
            $scope.openTakeDraftModal = function() {
                if (!determineSelected()) {return;}
                var params = {
                    methodname: 'fetch',
                    channelName: 'app',
                    indexName: $scope.basicParams.indexName,
                    nodeId: $stateParams.nodeid,
                    serviceid: 'mlf_bigdataexchange',
                    guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                };
                //              params = angular.extend(params, $scope.basicParams);
                var isOnlyOne = !($scope.data.selectedArray.length > 1);
                var modalInstance = resCtrModalService.fullTakeDraft(params, isOnlyOne, $scope.data.selectedArray);
                modalInstance.result.then(function(data) {
                    takeDraftDownloadImgs(data).then(function() {
                        initOperFlag();
                    });
                }, function() {
                    initOperFlag();
                });
            };

            /**
             * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
             * @param  {[type]} data [description]
             * @return {[type]}      [description]
             */
            function takeDraftDownloadImgs(data) {
                var deferred = $q.defer();
                var needDownloadImg = false;
                for (var i = 0; i < data.REPORTS.length; i++) {
                    if (data.REPORTS[i].PICERROR == 1) {
                        needDownloadImg = true;
                        break;
                    }
                }
                if (needDownloadImg) {
                    resCtrModalService.takeDraftDownloadImgs(data, function(res) {
                        deferred.resolve();
                    });
                } else {
                    deferred.resolve();
                }
                return deferred.promise;
            }

            /**
             * [CreationAxis description]个人素材
             */
            $scope.CreationAxis = function() {
                if (!determineSelected()) {return;}
                var params = {
                    typeid: 'zyzx',
                    //                  methodname: 'batchPersonalMaterial',
                    serviceid: 'mlf_bigdataexchange',
                    channelName: 'app',
                    typeName: $stateParams.typename,
                    nodeId: $stateParams.nodeid,
                    indexName: $scope.basicParams.indexName,
                    guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                    modelid: 'creation',
                };
                params.guid = trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ',');
                resourceCenterService.setBigDataCreation(params).then(function(data) {
                    modalDialog.alertType('添加成功', '', 'success', false, function() {
                        $scope.data.selectedArray = [];
                    });
                });
            };

            /**
             * [collect description]收藏
             */
            $scope.collect = function() {
                if (!determineSelected()) {return;}
                var params = {
                    typeid: 'zyzx',
                    //                  methodname: 'batchPersonalMaterial',
                    serviceid: 'mlf_bigdataexchange',
                    channelName: 'app',
                    typeName: $stateParams.typename,
                    nodeId: $stateParams.nodeid,
                    indexName: $scope.basicParams.indexName,
                    methodname: 'collect',
                    guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('收藏成功!', '', 'success', false, function() {
                        $scope.data.selectedArray = [];
                    });
                });
            };

            /**
             * [openReserveDraftModal description]预留
             */
            $scope.openReserveDraftModal = function() {
                if (!determineSelected()) {return;}
                var resCtrModalServiceModal = resCtrModalService.reserveDraft($scope.data.selectedArray);
                resCtrModalServiceModal.result.then(function(result) {
                    console.log(result, 11);
                    delete result.items;
                    var params = {
                        typeid: 'zyzx',
                        // methodname: 'batchPersonalMaterial',
                        serviceid: 'mlf_bigdataexchange',
                        channelName: 'app',
                        typeName: $stateParams.typename,
                        nodeId: $stateParams.nodeid,
                        indexName: $scope.basicParams.indexName,
                        guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                        methodname: 'delay',
                        //                      SourceName: "资源中心-网站-%E6%94%BF%E6%B2%BB"
                    };
                    params = angular.extend(params, result);
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        modalDialog.alertType('预留成功!', '', 'success', false, function() {
                            initOperFlag();
                            $scope.data.selectedArray = [];
                        });
                    }, function() {

                        /* initOperFlag();
                        $scope.data.selectedArray = [];*/
                    });
                });
            };

            /**
             * [printbtn description]打印
             */
            $scope.printbtn = function() {
                if (!determineSelected()) {return;}
                var params = {
                    'serviceid': 'app',
                    'modelid': 'detailData',
                    'guid': trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                    'channelName': 'app',
                    'typeid': 'zyzx',
                    'indexName': $scope.basicParams.indexName,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                    trsPrintService.trsPrintBigData(data);
                });
            };

            /**
             * [export description]导出
             */
            $scope.export = function() {
                if (!determineSelected()) {return;}
                var params = {
                    serviceid: 'mlf_exportword',
                    methodname: 'exportBigDataDocs',
                    GUIDS: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                    CHANNELNAMES: 'app',
                    indexName: $scope.basicParams.indexName
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    window.open('/wcm/app/file/read_file.jsp?FileName=' + data);
                });
            };

            /**
             * [fullTextSearch description;全文检索]
             * @param  {[type]} ev [description:按下空格也能提交]
             */
            $scope.fullTextSearch = function(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {

                }
            };

            /**
             * [initOperFlag description] 初始化取签见撤重
             */
            function initOperFlag() {
                var docIds = trsspliceString.spliceString($scope.data.items, 'ZB_GUID', ',');
                if (docIds) {
                    var params = {
                        methodname: 'queryFlag',
                        serviceid: 'mlf_bigdataexchange',
                        guids: docIds
                    };
                    params = angular.extend(params, $scope.basicParams);
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        $scope.data.operFlags = [];
                        var temp = data;
                        for (var i in temp) {
                            if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                                $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                            }
                        }
                    });
                }
                $scope.data.selectedArray = [];
            }

            /**
             * [showOperFlag description] 显示取签见撤重标志
             * @param  {[type]} guid      [description]
             * @param  {[type]} flagIndex [description]
             * @return {[type]}           [description]
             */
            $scope.showOperFlag = function(guid, flagIndex) {
                var temp = queryItemBYGUID(guid);
                if (!!temp) {
                    return queryItemBYGUID(guid).OPERFLAG.substr(flagIndex, 1) == '1';
                } else {
                    return false;
                }
            };

            /**
             * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
             * @param  {[type]} guid [description]
             * @return {[type]}      [description]
             */
            function queryItemBYGUID(guid) {
                for (var i in $scope.data.operFlags) {
                    if (guid == $scope.data.operFlags[i].GUID) {
                        return $scope.data.operFlags[i];
                    }
                }
            }

            /**
             * [selectAll description:全选]
             */
            $scope.selectAll = function() {
                $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
            };

            /**
             * [selectDoc 单选]
             * @param  {[type]} item [description：单个对象]
             */
            $scope.selectDoc = function(item) {
                var index = $scope.data.selectedArray.indexOf(item);
                if (index < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice(index, 1);
                }
            };

            /**
             * [viewBigDataInfo description] 取签见撤重 点击弹出
             * @param  {[type]} ChnlDocId  [description] 稿件id
             * @param  {[type]} showRepeat [description] 类型
             * @return {[type]}            [description]
             */
            $scope.viewBigDataInfo = function(ChnlDocId, showRepeat, showClick) {
                var operFlags = queryItemBYGUID(ChnlDocId).OPERFLAG;
                var infoModal = resCtrModalService.bigDataInfoModal(ChnlDocId, showRepeat, showClick, operFlags);
            };

            /**
             * [pageChanged description]分页
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                $scope.params.pageNum = $scope.page.CURRPAGE;
                $scope.data.currPage = $scope.page.CURRPAGE;
                requestData();
                resourceCenterService.scrollTop($element);
            };
            $scope.selectPageNum = function() {
                $scope.params.pageNum = $scope.page.CURRPAGE;
                $scope.data.currPage = $scope.page.CURRPAGE;
                $scope.params.pageSize = $scope.page.PAGESIZE;
                requestData();
                resourceCenterService.scrollTop($element);
            };
            $scope.jumpToPage = function() {
                $scope.params.pageNum = $scope.data.currPage;
                $scope.page.CURRPAGE = $scope.data.currPage;
                requestData();
                resourceCenterService.scrollTop($element);
            };

            /**
             * [quickPreview description] 快速预览模式
             * @return {[type]} [description]
             */
            $scope.quickPreview = function() {
                $scope.params.keyword = JSON.parse($scope.params.keyword);
                $scope.$root.filterData = {
                    page: $scope.page, // 分页
                    /* fromdate: $scope.data.fromdate, //开始时间
                    untildate: $scope.data.untildate, //结束时间*/
                    paramsKeyword: $scope.params.keyword, // 其他条件
                    area: $scope.data.area, // 地域信息
                    docType: $scope.data.docType, // 当前稿件类型
                    themeType: $scope.data.themeType, // 当前主题
                    keyType: $scope.data.keyType // 当前检索信息
                };
                if ($scope.data.fromdate && $scope.data.fromdate != '') {
                    $scope.$root.filterData.fromdate = $scope.data.fromdate; // 开始时间
                    $scope.$root.filterData.untildate = $scope.data.untildate; // 结束时间
                }
                if ($scope.status.hasphoto) { // 是否图集稿，是则直接传递图集列表数据
                    $scope.$root.filterData.listData = $scope.data.items;
                    $scope.$root.filterData.singleGraph = $scope.status.singleGraph; // 是否单图
                }
                $state.go('front.networksource.classifiedresource.app.quickpreview', $stateParams);
            };

            /**
             * 要求 同时判断key,name,两个参数同时存在才进行排重
             * key,name,为要排重的属性
             * [listPaiChong 去除重复数组]
             * @param  {[type]} data  [Array]
             * @param  {[type]} key   [String]
             * @param  {[type]} name   [String]
             * @return {[type]}       [Array]
             */
            function listPaiChong(data, key, name) {
                var List = [{
                    'DOCTITLE': '',
                    'ZB_SOURCE_SITE': ''
                }]; // 去重后的数据
                for (var i = 0; i < data.length; i++) {
                    for (var k = 0; k < List.length; k++) {
                        // 遍历保存后的List数据，用indexOf查找同时存在的key,name当条数据
                        if (List[k][key].indexOf(data[i][key]) > -1 && List[k][name].indexOf(data[i][name]) > -1) {
                            // 处理序号后跳出循环
                            var number = List[k].NUMBER;
                            List[k] = data[i]; // 把最早的重复数据 赋值给LIST的数据
                            List[k].NUMBER = number + ',' + List[k].NUMBER;
                            break;
                        } else {
                            // 在key,name不等的情况下，只保存一条数据，防止重复加载push数据
                            if (k == List.length - 1) {
                                List.push(data[i]);
                                break;
                            }
                        }
                    }
                }
                // 删除初始化的第一条数据
                List.splice(0, 1);
                // 处理List连续序号为“-”连接
                for (var j = 0; j < List.length; j++) {
                    List[j].NUMBER = ListPaiChongChuLi(List[j].NUMBER);
                }
                return List;
            }

            /**
             * [ListPaiChongChuLi 处理数据排重连续数据为“-”连接]
             * @param {[type]} item [数据处理的字符串]
             * @return {[type]}       [string]
             */
            function ListPaiChongChuLi(item) {
                // 拆分字符串为数组
                var testArray = item.split(',');
                // 如果item传入为 "1" 返回数据为 "0-1"
                if (testArray.length === 1) {
                    return item;
                }
                var resultArray = ['0'];
                for (var i = 0; i < testArray.length; i++) {
                    var index = parseInt(testArray[i]);
                    var resultLastIndex = resultArray[resultArray.length - 1];
                    if (resultLastIndex.indexOf('-') > 0) {
                        var resultLastIndexArray = resultLastIndex.split('-');
                        resultLastIndex = resultLastIndexArray[resultLastIndexArray.length - 1];
                        if (index - (parseInt(resultLastIndex)) === 1) {
                            resultArray[resultArray.length - 1] = resultLastIndexArray[0] + '-' + index;
                        } else {
                            resultArray.push(index.toString());
                        }
                    } else {
                        if (index - (parseInt(resultLastIndex)) === 1) {
                            resultArray[resultArray.length - 1] = resultLastIndex + '-' + index;
                        } else {
                            resultArray.push(index.toString());
                        }
                    }
                }
                if (resultArray[0].indexOf('0-') === 0) {
                    var headArray = resultArray[0].split('-');
                    for (var i = 0; i < testArray.length - 1; i++) {
                        if (parseInt(testArray[i]) > parseInt(headArray[0]) && parseInt(testArray[i]) <= parseInt(headArray[1])) {
                            resultArray[0] = parseInt(testArray[i]) === parseInt(headArray[1]) ? headArray[1] : testArray[i] + '-' + headArray[1];
                            break;
                        }
                    }
                } else {
                    resultArray.splice(0, 1);
                }
                return resultArray.join(',');
            }

            /**
             * [isOnly URL排重]
             * @return {Boolean} [description]
             */
            $scope.isOnly = function() {
                $scope.status.Only = !$scope.status.Only;
                clearPageData();
                requestData();
            };

            /**
             * [selectDoc description] 单选
             * @param  {[type]} item [description] 当前数据
             * @return {[type]}      [description]
             */
            $scope.selectDoc = function(item) {
                var index = $scope.data.selectedArray.indexOf(item);
                index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
            };

            /**
             * [singleGraphMode description] 是否为单图模式
             * @return {[type]} [description]
             */
            $scope.singleGraphMode = function() {
                $scope.page.CURRPAGE = 1;
                $scope.params.pageNum = $scope.page.CURRPAGE;
                $scope.data.items = [];
                $scope.status.singleGraph = !$scope.status.singleGraph;
                requestData();
            };

            /**
             * [loadMore description] 图集-加载更多图片
             * @return {[type]} [description]
             */
            $scope.imgLoadMore = function() {
                $scope.page.CURRPAGE++;
                $scope.params.pageNum = $scope.page.CURRPAGE;
                requestData();
            };

            /**
             * [scrollShowMore description] 滚动加载更多图片
             * @return {[type]} [description]
             */
            // $scope.scrollShowMore = function() {
            //     if ($scope.status.hasphoto) {
            //         $scope.imgLoadMore();
            //     }
            // };

            /**
             * [openPageForSearch description] 打开高级检索新页面
             * @return {[date]} [description]
             */
            $scope.openPageForSearch = function() {
                var url = $state.href('resadvancedsearch');
                window.open(url, '_blank');
            };
        }
    ]);
